<template>
  <div
    class="flex-1 min-h-0 flex items-center justify-center p-8"
    :class="[wrapperClass]"
    :style="{ backgroundColor: bgColor }"
  >
    <div class="max-w-md w-full text-center relative">
      <div
        v-if="showPattern"
        class="absolute inset-0 opacity-[0.03] pointer-events-none rounded-2xl"
        :style="{ backgroundImage: `radial-gradient(circle at 1px 1px, ${accentColor} 1px, transparent 0)`, backgroundSize: '24px 24px' }"
      />
      <div class="relative">
        <div
          class="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 hover:scale-105"
          :style="{ backgroundColor: iconBgColor, color: accentColor }"
        >
          <slot name="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>
          </slot>
        </div>
        <h2
          class="text-xl font-serif font-medium mb-2"
          :style="{ color: titleColor }"
        >
          {{ title }}
        </h2>
        <p
          v-if="description"
          class="text-sm leading-relaxed mb-6"
          :style="{ color: descriptionColor }"
        >
          {{ description }}
        </p>
        <button
          v-if="ctaText"
          type="button"
          class="px-5 py-2.5 rounded-xl text-sm font-bold transition-all hover:opacity-90 active:scale-[0.98]"
          :style="{ backgroundColor: ctaBgColor, color: ctaTextColor }"
          @click="$emit('cta-click')"
        >
          {{ ctaText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: 'Kreiraj stranu' },
  description: { type: String, default: 'Kada kreiraš stranu, ostatak sadržaja će se pojaviti ovde.' },
  ctaText: { type: String, default: '' },
  wrapperClass: { type: String, default: '' },
  bgColor: { type: String, default: '#f8fafc' },
  titleColor: { type: String, default: '#1c4848' },
  descriptionColor: { type: String, default: '#64748b' },
  accentColor: { type: String, default: '#1c4848' },
  iconBgColor: { type: String, default: 'rgba(28, 72, 72, 0.08)' },
  ctaBgColor: { type: String, default: '#1c4848' },
  ctaTextColor: { type: String, default: '#fff' },
  showPattern: { type: Boolean, default: true },
});
defineEmits(['cta-click']);
</script>
